var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPointGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.895,
    height: 16,
    viewBox: "0 0 16.895 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 887"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 445",
    d: "M10.8 0a1 1 0 0 1 .584.188l3.724 2.677a1 1 0 0 1 .366.5L16.9 7.688a1 1 0 0 1 0 .624l-1.419 4.323a1 1 0 0 1-.366.5l-3.724 2.677A1 1 0 0 1 10.8 16H6.2a1 1 0 0 1-.584-.188l-3.728-2.677a1 1 0 0 1-.366-.5L.1 8.312a1 1 0 0 1 0-.624l1.422-4.323a1 1 0 0 1 .366-.5L5.612.188A1 1 0 0 1 6.2 0z",
    transform: "translate(-.053)",
    style: {
      fill: "#70806e"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.947 12)",
    style: {
      fill: "#fff4f4",
      fontSize: 11,
      fontFamily: "NunitoSans-Bold,Nunito Sans",
      fontWeight: 700
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPointGreen);
export default __webpack_public_path__ + "static/media/icon-point-green.77429761.svg";
export { ForwardRef as ReactComponent };